import axios from 'axios'

// Determinar la URL base según el entorno
const getBaseURL = () => {
  // En desarrollo, usar el proxy configurado en vite
  if (import.meta.env.DEV) {
    return '/api'
  }
  // En producción, usar la URL del backend desde variables de entorno o por defecto
  return import.meta.env.VITE_API_URL || 'http://localhost:3013/api'
}

// Configurar axios con interceptores
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
})

// Interceptor para agregar token a todas las requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const authService = {
  // Login
  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    return response.data
  },

  // Logout
  async logout() {
    try {
      await api.post('/auth/logout')
    } catch (error) {
      console.error('Error en logout:', error)
    }
  },

  // Verificar token
  async verifyToken() {
    const response = await api.get('/auth/me')
    return response.data.user
  },

  // Obtener usuario actual
  async getCurrentUser() {
    const response = await api.get('/auth/me')
    return response.data.user
  }
}

export default api 